module.exports = __webpack_public_path__ + "img/gtbank.3fe97b48.png";